(function(){"use strict";try{if(document){const r=document.createElement("style");r.id="manifold-vue-component-library-1",r.dataset.version="3.2.0",r.appendChild(document.createTextNode('@layer manifold-components{:root{--manifold-button--max-width--base: 335px;--manifold-button--max-width--small: 202px}.m-button{display:inline-flex;height:3rem;align-items:center;justify-content:center;gap:.5rem;flex-shrink:0;box-sizing:border-box;cursor:pointer;text-align:center;text-decoration:none;border-radius:var(--manifold-border-radius--md, 8px);border-width:2px;border-style:solid;border-color:var(--manifold-color--border--default);font-weight:600}.m-button:disabled,.m-button[disabled=true],.m-button[aria-disabled=true]{cursor:not-allowed;color:var(--manifold-color--text--muted)}.m-button--primary,.m-button--secondary,.m-button--tertiary{font-feature-settings:"clig" off,"liga" off;font-size:.875rem;line-height:.875rem;letter-spacing:.42px;text-transform:uppercase}.m-button--primary{background-color:var(--manifold-color--surface--contrast);color:var(--manifold-color--text--contrast);border-color:transparent}:where(.manifold-scheme-light) .m-button--primary:disabled,:where(.manifold-scheme-light) .m-button--primary[disabled=true],:where(.manifold-scheme-light) .m-button--primary[aria-disabled=true]{background-color:var(--manifold-color--neutral--200)}@media (prefers-color-scheme: light){.m-button--primary:disabled:where(:not(.manifold-scheme-dark .m-button--primary:disabled,.manifold-scheme-light .m-button--primary:disabled,.manifold-scheme-dark .m-button--primary[disabled=true],.manifold-scheme-light .m-button--primary[disabled=true],.manifold-scheme-dark .m-button--primary[aria-disabled=true],.manifold-scheme-light .m-button--primary[aria-disabled=true])),.m-button--primary[disabled=true]:where(:not(.manifold-scheme-dark .m-button--primary:disabled,.manifold-scheme-light .m-button--primary:disabled,.manifold-scheme-dark .m-button--primary[disabled=true],.manifold-scheme-light .m-button--primary[disabled=true],.manifold-scheme-dark .m-button--primary[aria-disabled=true],.manifold-scheme-light .m-button--primary[aria-disabled=true])),.m-button--primary[aria-disabled=true]:where(:not(.manifold-scheme-dark .m-button--primary:disabled,.manifold-scheme-light .m-button--primary:disabled,.manifold-scheme-dark .m-button--primary[disabled=true],.manifold-scheme-light .m-button--primary[disabled=true],.manifold-scheme-dark .m-button--primary[aria-disabled=true],.manifold-scheme-light .m-button--primary[aria-disabled=true])){background-color:var(--manifold-color--neutral--200)}}:where(.manifold-scheme-dark) .m-button--primary:disabled,:where(.manifold-scheme-dark) .m-button--primary[disabled=true],:where(.manifold-scheme-dark) .m-button--primary[aria-disabled=true]{background-color:var(--manifold-color--neutral--400)}@media (prefers-color-scheme: dark){.m-button--primary:disabled:where(:not(.manifold-scheme-dark .m-button--primary:disabled,.manifold-scheme-light .m-button--primary:disabled,.manifold-scheme-dark .m-button--primary[disabled=true],.manifold-scheme-light .m-button--primary[disabled=true],.manifold-scheme-dark .m-button--primary[aria-disabled=true],.manifold-scheme-light .m-button--primary[aria-disabled=true])),.m-button--primary[disabled=true]:where(:not(.manifold-scheme-dark .m-button--primary:disabled,.manifold-scheme-light .m-button--primary:disabled,.manifold-scheme-dark .m-button--primary[disabled=true],.manifold-scheme-light .m-button--primary[disabled=true],.manifold-scheme-dark .m-button--primary[aria-disabled=true],.manifold-scheme-light .m-button--primary[aria-disabled=true])),.m-button--primary[aria-disabled=true]:where(:not(.manifold-scheme-dark .m-button--primary:disabled,.manifold-scheme-light .m-button--primary:disabled,.manifold-scheme-dark .m-button--primary[disabled=true],.manifold-scheme-light .m-button--primary[disabled=true],.manifold-scheme-dark .m-button--primary[aria-disabled=true],.manifold-scheme-light .m-button--primary[aria-disabled=true])){background-color:var(--manifold-color--neutral--400)}}:where(.manifold-scheme-light) .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),:where(.manifold-scheme-light) .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]){background-color:var(--manifold-color--neutral--600)}@media (prefers-color-scheme: light){.m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]):where(:not(.manifold-scheme-dark .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-dark .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]))),.m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]):where(:not(.manifold-scheme-dark .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-dark .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]))){background-color:var(--manifold-color--neutral--600)}}:where(.manifold-scheme-dark) .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),:where(.manifold-scheme-dark) .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]){background-color:var(--manifold-color--neutral--200)}@media (prefers-color-scheme: dark){.m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]):where(:not(.manifold-scheme-dark .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-dark .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]))),.m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]):where(:not(.manifold-scheme-dark .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-dark .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]),.manifold-scheme-light .m-button--primary:focus:not(:disabled,[disabled=true],[aria-disabled=true]))){background-color:var(--manifold-color--neutral--200)}}.m-button--primary:active:not(:disabled,[disabled=true],[aria-disabled=true]){background-color:var(--manifold-color--surface--primary);color:var(--manifold-color--text--primary);border-color:var(--manifold-color--border--default)}.m-button--secondary{background-color:var(--manifold-color--surface--primary);color:var(--manifold-color--text--primary);border-color:var(--manifold-color--border--default)}.m-button--tertiary{background-color:var(--manifold-color--surface--secondary);color:var(--manifold-color--text--primary)}.m-button--secondary:disabled,.m-button--secondary[disabled=true],.m-button--secondary[aria-disabled=true],.m-button--tertiary:disabled,.m-button--tertiary[disabled=true],.m-button--tertiary[aria-disabled=true]{background-color:transparent;border-color:var(--manifold-color--border--disabled)}.m-button--secondary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.m-button--secondary:focus:not(:disabled,[disabled=true],[aria-disabled=true]),.m-button--tertiary:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.m-button--tertiary:focus:not(:disabled,[disabled=true],[aria-disabled=true]){background-color:var(--manifold-color--surface--accent);color:var(--manifold-color--text--primary)}.m-button--secondary:active:not(:disabled,[disabled=true],[aria-disabled=true]),.m-button--tertiary:active:not(:disabled,[disabled=true],[aria-disabled=true]){background-color:var(--manifold-color--surface--contrast);color:var(--manifold-color--text--contrast);border-color:var(--manifold-color--surface--contrast)}.m-button--ghost{background-color:transparent;border-color:transparent;color:var(--manifold-color--text--primary);font-size:1rem;font-style:normal;line-height:1.5rem;text-decoration-line:underline}.m-button--ghost:hover:not(:disabled,[disabled=true],[aria-disabled=true]),.m-button--ghost:focus:not(:disabled,[disabled=true],[aria-disabled=true]){color:var(--manifold-color--text--secondary)}.m-button--ghost:active:not(:disabled,[disabled=true],[aria-disabled=true]){color:var(--manifold-color--neutral--400)}.m-button--base{width:var(--manifold-button--max-width--base);max-width:var(--manifold-button--max-width--base);padding:1.125rem 1rem}.m-button--base-icon{width:3rem;max-width:3rem;padding:.875rem}.m-button--small{width:var(--manifold-button--max-width--small);max-width:var(--manifold-button--max-width--small);height:2.5rem;padding:.875rem .625rem}.m-button--small-icon{width:2.5rem;height:2.5rem;max-width:2.5rem;max-height:2.5rem;padding:.875rem .625rem}.m-button--auto{width:auto;height:auto}}')),document.head.appendChild(r)}}catch(r){console.error("[vite-plugin-css-injected-by-js][@manifoldxyz/vue-component-library]:",r)}})();
import { defineComponent as y, Comment as x, mergeProps as w, cloneVNode as B, h as v, toRefs as D, ref as h, getCurrentInstance as L, reactive as j, watch as b, watchEffect as F, markRaw as R, effectScope as W, Fragment as V, computed as A, nextTick as q, onUnmounted as z, inject as G, provide as H, unref as O, useAttrs as K, openBlock as T, createBlock as g, withCtx as C, renderSlot as _, createCommentVNode as Q, Transition as X } from "vue";
const Y = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [o, a] of e)
    n[o] = a;
  return n;
};
function Z(t, e) {
  const n = typeof t == "string" && !e ? `${t}Context` : e, o = Symbol(n);
  return [(a) => {
    const r = G(o, a);
    if (r || r === null)
      return r;
    throw new Error(
      `Injection \`${o.toString()}\` not found. Component must be used within ${Array.isArray(t) ? `one of the following components: ${t.join(
        ", "
      )}` : `\`${t}\``}`
    );
  }, (a) => (H(o, a), a)];
}
function J(t) {
  let e = !1, n;
  const o = W(!0);
  return (...a) => (e || (n = o.run(() => t(...a)), e = !0), n);
}
function ee(t) {
  return typeof t == "function" ? t() : O(t);
}
const te = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function I(t) {
  var e;
  const n = ee(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function S(t) {
  return t ? t.flatMap((e) => e.type === V ? S(e.children) : [e]) : [];
}
function ne(t, e) {
  const n = h(t);
  function o(a) {
    return e[n.value][a] ?? n.value;
  }
  return {
    state: n,
    dispatch: (a) => {
      n.value = o(a);
    }
  };
}
const M = y({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(t, { attrs: e, slots: n }) {
    return () => {
      var o, a;
      if (!n.default)
        return null;
      const r = S(n.default()), l = r.findIndex((p) => p.type !== x);
      if (l === -1)
        return r;
      const s = r[l];
      (o = s.props) == null || delete o.ref;
      const c = s.props ? w(e, s.props) : e;
      e.class && (a = s.props) != null && a.class && delete s.props.class;
      const d = B(s, c);
      for (const p in c)
        p.startsWith("on") && (d.props || (d.props = {}), d.props[p] = c[p]);
      return r.length === 1 ? d : (r[l] = d, r);
    };
  }
}), oe = y({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(t, { attrs: e, slots: n }) {
    const o = t.asChild ? "template" : t.as;
    return typeof o == "string" && ["area", "img", "input"].includes(o) ? () => v(o, e) : o !== "template" ? () => v(t.as, e, { default: n.default }) : () => v(M, e, { default: n.default });
  }
});
function U() {
  const t = h(), e = A(() => {
    var n, o;
    return ["#text", "#comment"].includes((n = t.value) == null ? void 0 : n.$el.nodeName) ? (o = t.value) == null ? void 0 : o.$el.nextElementSibling : I(t);
  });
  return {
    primitiveElement: t,
    currentElement: e
  };
}
function ae(t, e) {
  const n = h({}), o = h("none"), a = t.value ? "mounted" : "unmounted", { state: r, dispatch: l } = ne(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), s = (i) => {
    var u;
    if (te) {
      const f = new CustomEvent(i, { bubbles: !1, cancelable: !1 });
      (u = e.value) == null || u.dispatchEvent(f);
    }
  };
  b(
    t,
    async (i, u) => {
      var f;
      const $ = u !== i;
      if (await q(), $) {
        const k = o.value, E = N(e.value);
        i ? (l("MOUNT"), s("enter"), E === "none" && s("after-enter")) : E === "none" || ((f = n.value) == null ? void 0 : f.display) === "none" ? (l("UNMOUNT"), s("leave"), s("after-leave")) : u && k !== E ? (l("ANIMATION_OUT"), s("leave")) : (l("UNMOUNT"), s("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const c = (i) => {
    const u = N(e.value), f = u.includes(
      i.animationName
    ), $ = r.value === "mounted" ? "enter" : "leave";
    i.target === e.value && f && (s(`after-${$}`), l("ANIMATION_END")), i.target === e.value && u === "none" && l("ANIMATION_END");
  }, d = (i) => {
    i.target === e.value && (o.value = N(e.value));
  }, p = b(
    e,
    (i, u) => {
      i ? (n.value = getComputedStyle(i), i.addEventListener("animationstart", d), i.addEventListener("animationcancel", c), i.addEventListener("animationend", c)) : (l("ANIMATION_END"), u == null || u.removeEventListener("animationstart", d), u == null || u.removeEventListener("animationcancel", c), u == null || u.removeEventListener("animationend", c));
    },
    { immediate: !0 }
  ), m = b(r, () => {
    const i = N(e.value);
    o.value = r.value === "mounted" ? i : "none";
  });
  return z(() => {
    p(), m();
  }), {
    isPresent: A(
      () => ["mounted", "unmountSuspended"].includes(r.value)
    )
  };
}
function N(t) {
  return t && getComputedStyle(t).animationName || "none";
}
y({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(t, { slots: e, expose: n }) {
    var o;
    const { present: a, forceMount: r } = D(t), l = h(), { isPresent: s } = ae(a, l);
    n({ present: s });
    let c = e.default({ present: s });
    c = S(c || []);
    const d = L();
    if (c && (c == null ? void 0 : c.length) > 1) {
      const p = (o = d == null ? void 0 : d.parent) != null && o.type.name ? `<${d.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${p}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((m) => `  - ${m}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => r.value || a.value || s.value ? v(e.default({ present: s })[0], {
      ref: (p) => {
        const m = I(p);
        return typeof (m == null ? void 0 : m.hasAttribute) > "u" || (m != null && m.hasAttribute("data-radix-popper-content-wrapper") ? l.value = m.firstElementChild : l.value = m), m;
      }
    }) : null;
  }
});
j({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
J(() => h([]));
const [P, ce] = Z("CollectionProvider");
y({
  name: "CollectionSlot",
  setup(t, { slots: e }) {
    const n = P(), { primitiveElement: o, currentElement: a } = U();
    return b(a, () => {
      n.collectionRef.value = a.value;
    }), () => v(M, { ref: o }, e);
  }
});
y({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(t, { slots: e, attrs: n }) {
    const o = P(), { primitiveElement: a, currentElement: r } = U();
    return F((l) => {
      if (r.value) {
        const s = R(r.value);
        o.itemMap.value.set(s, { ref: r.value, value: t.value }), l(() => o.itemMap.value.delete(s));
      }
    }), () => v(M, { ...n, [o.attrName]: "", ref: a }, e);
  }
});
function re() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
re();
const se = {
  name: "MButton"
}, de = /* @__PURE__ */ y({
  ...se,
  // manually pass them down because we want to disable links when disabled
  inheritAttrs: !1,
  props: {
    as: { default: "button" },
    variant: { default: "secondary" },
    size: { default: "base" },
    disabled: { type: Boolean }
  },
  setup(t) {
    const e = t, { href: n, ...o } = K(), a = A(() => e.as === "a" && !e.disabled ? n : void 0);
    return (r, l) => (T(), g(O(oe), w({
      class: ["m-button", `m-button--${e.variant} m-button--${e.size}`],
      as: e.as
    }, { ...o }, {
      "aria-disabled": e.disabled,
      disabled: e.disabled,
      href: a.value
    }), {
      default: C(() => [
        r.$slots.icon ? _(r.$slots, "icon", { key: 0 }) : Q("", !0),
        _(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "as", "aria-disabled", "disabled", "href"]));
  }
}), le = {
  name: "FadeTransition"
};
function ie(t, e, n, o, a, r) {
  return T(), g(X, w({ name: "m-transition__fade" }, t.$attrs), {
    default: C(() => [
      _(t.$slots, "default")
    ]),
    _: 3
  }, 16);
}
const pe = /* @__PURE__ */ Y(le, [["render", ie]]);
export {
  pe as F,
  de as _,
  Y as a
};
